// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__101PE","icon":"InfoPanel_icon__1tlkj"};